import { Cores } from 'src/componentes/styles'
import { FormUnform } from 'src/componentes/unform/form'
import styled, { css } from 'styled-components'

export const Form = styled(FormUnform)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Mr = styled.div`
  margin-right: 10px;
`

export const Campo = styled.div<{ mr?: boolean }>`
  flex: 1;

  ${({ mr }) =>
    mr &&
    css`
      margin-right: 10px;
    `}
`
export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`

export const Dados = styled.div`
  margin-top: 25px;
`

export const ContainerAcoesEsquerda = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  button {
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    svg {
      width: 24px;
      height: 24px;
      fill: ${Cores.CINZA_2};
    }

    &:hover {
      background: ${Cores.CINZA_3_MAIS_CLARO};

      svg {
        fill: ${Cores.SECUNDARIA_1};

        path {
          fill: ${Cores.SECUNDARIA_1};
        }
      }
    }

    &:disabled {
      cursor: not-allowed;
    }
  }
`

export const UrlResetSenha = styled.p`
  margin: 12px 0 0;
  word-break: break-all;
  font-size: 14px;
  line-height: 1.4;
  color: ${Cores.CINZA_2};
`

export const ConteudoModalResetSenha = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
